import { c as _c } from "react/compiler-runtime";
import { FieldsType } from '@systemeio/digital-store-shared';
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields';
import { useEffect } from 'react';
import { InitFieldsInterface } from '../components/contact-fields';
type ArgsType = {
  savedFields: FieldsType[];
  onChange: (fields: FieldsType[]) => void;
  initFields?: InitFieldsInterface[];
};
export const useStoreContactFields = t0 => {
  const $ = _c(15);
  const {
    savedFields,
    onChange,
    initFields
  } = t0;
  const {
    fields
  } = useContactFields();
  const isReady = !!fields;
  let t1;
  if ($[0] !== fields || $[1] !== initFields || $[2] !== onChange || $[3] !== savedFields.length) {
    t1 = () => {
      if (fields && savedFields.length === 0) {
        const newFields = [];
        fields.items.forEach(f => {
          const initField_0 = initFields?.find(initField => initField.slug === f.slug);
          if (initField_0) {
            newFields.push({
              fieldName: f.fieldName,
              slug: f.slug,
              required: initField_0.required
            });
          }
        });
        onChange(newFields);
      }
    };
    $[0] = fields;
    $[1] = initFields;
    $[2] = onChange;
    $[3] = savedFields.length;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== fields || $[6] !== initFields || $[7] !== savedFields.length) {
    t2 = [fields, initFields, savedFields.length];
    $[5] = fields;
    $[6] = initFields;
    $[7] = savedFields.length;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  if ($[9] !== fields?.items || $[10] !== savedFields) {
    t3 = fields?.items.filter(field => !savedFields.some(initField_1 => initField_1.slug === field.slug));
    $[9] = fields?.items;
    $[10] = savedFields;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const availableFields = t3;
  let t4;
  if ($[12] !== availableFields || $[13] !== isReady) {
    t4 = {
      availableFields,
      isReady
    };
    $[12] = availableFields;
    $[13] = isReady;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};